module.exports = __webpack_public_path__ + "media/homepage/student-lockup-e122de96.webp";